export const dvhToPixels = (dvh) => {
  const dynamicHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  return (dvh * dynamicHeight) / 100;
};
